import NoAllergies from "../../../../assets/no_allergy.svg";
import EggsAllergy from "../../../../assets/egg_allergy.svg";
import MilkAndDiaryAllergy from "../../../../assets/milk_dairy_allergy.svg";
import PeanutsAllergy from "../../../../assets/peanuts_allergy.svg";
import SeafoodAllergy from "../../../../assets/seafood_allergy.svg";
import SesameAllergy from "../../../../assets/sesame_seeds_allergy.svg";
import ShellfishAllergy from "../../../../assets/shellfish_allergy.svg";
import SoyAllergy from "../../../../assets/soy_allergy.svg";
import TreeNutsAllergy from "../../../../assets/tree_nuts_allergy.svg";
import WheatGlutenAllergy from "../../../../assets/wheat_gluten_allergy.svg";
import OtherAllergy from "../../../../assets/other_allergy.svg";

export const allergiesOptions = [
  { label: "NONE", value: "none" },
  { label: "Egg", value: "egg" },
  { label: "Milk and Dairy", value: "milk and dairy" },
  { label: "Peanuts", value: "peanuts" },
  { label: "Seafood", value: "seafood" },
  { label: "Sesame", value: "sesame" },
  { label: "Shellfish", value: "shellfish" },
  { label: "Soy", value: "soy" },
  { label: "Tree Nuts", value: "tree nuts" },
  { label: "Wheat-Gluten", value: "wheat-gluten" },
  { label: "OTHER", value: "other" },
];

export const allergiesImageMapper = {
  none: NoAllergies,
  egg: EggsAllergy,
  "milk and dairy": MilkAndDiaryAllergy,
  peanuts: PeanutsAllergy,
  seafood: SeafoodAllergy,
  sesame: SesameAllergy,
  shellfish: ShellfishAllergy,
  soy: SoyAllergy,
  "tree nuts": TreeNutsAllergy,
  "wheat-gluten": WheatGlutenAllergy,
  other: OtherAllergy,
};

export const allergiesNameMapper = {
  none: "NONE",
  egg: "Egg",
  "milk and dairy": "Milk and Dairy",
  peanuts: "Peanuts",
  seafood: "Seafood",
  sesame: "Sesame",
  shellfish: "Shellfish",
  soy: "Soy",
  "tree nuts": "Tree Nuts",
  "wheat-gluten": "Wheat-Gluten",
  other: "OTHER",
};
